import { ObjectField } from '../../interfaces/object-field';
import { TableColumn } from '../../../../table/interfaces/table';
import { FieldCell } from './FieldCell';
import { FieldHeaderCell } from './FieldHeaderCell';
import { ObjectFieldsMetaData } from '../../interfaces/object-field-header';
import { NonConfigurableRowStatus } from '../NonConfigurableRowStatus';
import { shouldRenderFieldConfigCell } from '../../utils';
import { Integration } from '../../../../shared/interfaces/integration';

export interface ObjectFieldsTableGlobalContext {
  isViewMode?: boolean;
  selectedCount: number;
  totalCount: number;
  isListIndeterminate: boolean;
  isListIncluded: boolean;
  changeSelectAllCheckedState: (included: boolean) => void;
  changeCheckedState: (field: ObjectField, included: boolean) => void;
  updateFieldProperty: (field: ObjectField, key: string, value: unknown) => void;
}

export function getFieldsColumns(fieldHeaders: ObjectFieldsMetaData, pipeline: Integration) {
  let columns: TableColumn<ObjectField, ObjectFieldsTableGlobalContext>[] =
    fieldHeaders.columnConfigs.map((columnConfig, index) => {
      return {
        id: columnConfig.name,
        field: columnConfig.name,
        headerName: '',
        width: 100,
        isFlexible: index < 2,
        renderHeaderCell: ({ globalContext: g }) => {
          const {
            selectedCount,
            totalCount,
            isListIncluded,
            isListIndeterminate,
            isViewMode,
            changeSelectAllCheckedState
          } = g as ObjectFieldsTableGlobalContext;

          return (
            <FieldHeaderCell
              pipeline={pipeline}
              index={index}
              columnConfig={columnConfig}
              selectedCount={selectedCount}
              totalCount={totalCount}
              isViewMode={isViewMode}
              isListIncluded={isListIncluded}
              isListIndeterminate={isListIndeterminate}
              changeSelectAllCheckedState={changeSelectAllCheckedState}
            />
          );
        },
        shouldRenderCell: ({ row }) => {
          return shouldRenderFieldConfigCell(row.data, index, columns.length);
        },
        renderCell: ({ row, globalContext }) => (
          <FieldCell
            index={index}
            fieldDetails={row.data}
            columnConfig={columnConfig}
            isViewMode={globalContext!.isViewMode}
            handleToggleCheckedState={
              (globalContext as ObjectFieldsTableGlobalContext).changeCheckedState
            }
            updateFieldProperty={
              (globalContext as ObjectFieldsTableGlobalContext).updateFieldProperty
            }
          />
        )
      };
    });

  columns = [
    ...columns,
    {
      id: 'c1',
      field: 'actions',
      headerName: '',
      width: 0,
      justifyEnd: true,
      getColSpan: ({ row }) => (!row.data.isConfigurable ? [1, columns.length - 1] : undefined),
      renderCell: ({ row, globalContext: g }) => {
        if (row.data.isConfigurable) {
          return null;
        }

        return (
          <NonConfigurableRowStatus
            status={row.data.status.value}
            reason={row.data.status.statusReason}
            hideTooltip={g?.isViewMode}
          />
        );
      }
    }
  ];

  return columns;
}
